<template>
  <div v-if="data.flowInfo?.id && data.flowInfo?.nodes?.length" class="comp-xl-flow-stage">
    <jw-card :bordered="false">
      <!-- 基本信息 -->
      <div class="info">
        <div class="info-msg">
          <div class="info-title">
            <div class="info-block" />
            <div :title="data.flowInfo.name">{{ data.flowInfo?.name }}</div>
            <jw-tooltip v-if="data.flowInfo?.memo" :content="data.flowInfo?.memo">
              <template #content>
                <div class="tooltip-style">
                  {{ data.flowInfo?.memo }}
                </div>
              </template>
              <icon-info-circle class="tooltip-icon" :style="{ fontSize: 12 }" />
            </jw-tooltip>
          </div>

          <div class="info-status">
            <jw-space>
              <div class="info-status-tack">
                <div v-if="data.flowInfo?.status == '0'" class="stage-content-block stage-content-waiting">
                  <!-- <icon-minus-circle /> -->
                  <span>{{ $t('未开始') }}</span>
                </div>
                <div v-else-if="data.flowInfo?.status == '1'" class="stage-content-block stage-content-ing">
                  <!-- <icon-schedule /> -->
                  <span>{{ $t('进行中') }}</span>
                </div>
                <div v-else-if="data.flowInfo?.status == '5'" class="stage-content-block stage-content-success">
                  <!-- <icon-check-circle /> -->
                  <span>{{ $t('已完成') }}</span>
                </div>
              </div>
            </jw-space>
          </div>
        </div>

        <div class="info-operation">
          <template v-if="!(data.isStartFlow && data.flowInfo?.status == '1')">
            <template v-if="!isFinishedStatus">
              <div>
                <icon-stop class="stop-text stop-text-icon" />
                <span class="stop-text">流程已终止</span>
              </div>
              <jw-button @click="startFlow" type="outline" size="small">激活流程</jw-button>
            </template>
          </template>
          <jw-dropdown>
            <jw-button type="text" size="small">
              <qfei-icon-more-applications-outlined class="operation-icon" />
            </jw-button>
            <template #content>
              <template v-if="data.isStartFlow && data.flowInfo?.status == '1'">
                <jw-doption v-if="data.flowInfo.canEarlyDone" @click="stopFlow" type="outline" size="small">终止流程</jw-doption>
              </template>
              <jw-doption @click="checkOperation">操作记录</jw-doption>
            </template>
          </jw-dropdown>
        </div>
      </div>
      <!-- 流程图 -->
      <div ref="scrollableDiv" class="flow-stage-style">
        <draw-flow ref="drawFlowRef" :flowInfo="data.flowInfo" :scrollableDivWidth="data.scrollableDivWidth || scrollableDiv?.clientWidth" :nodes="data.flowInfo?.nodes" :edges="data.flowInfo?.sequences" :isFinishedStatus="isFinishedStatus" @cb="getNode" @cbScrollInit="scrollInit" @isFinished="isFinished"></draw-flow>
      </div>
      <div class="node-info-box pd-8" v-if="data.node">
        <div class="node-circle-all">
          <div class="node-current">当前节点</div>

          <div class="node-circle-name">
            <xl-label-text :isBold="true" :value="data.node?.data.label" :row="1" :width="200" />
          </div>
          <div class="node-circle-box">
            <div v-if="data.node?.data.status == '0'" class="node-circle1 stage-content-waiting">
              <div style="background: var(--color-text-3)"></div>
              <span>{{ $t('未开始') }}</span>
            </div>
            <div v-else-if="data.node?.data.status == '1'" class="node-circle2 stage-content-ing">
              <div style="background: rgb(var(--orange-5))"></div>
              <span>{{ $t('进行中') }}</span>
            </div>
            <div v-else-if="data.node?.data.status == '5'" class="node-circle3 stage-content-success">
              <div style="background: rgb(var(--green-5))"></div>
              <span>{{ $t('已完成') }}</span>
            </div>
          </div>
        </div>
        <div class="current-button" v-if="!data.nodeConfig?.mustUseByApi && data.isStartFlow && data.flowInfo?.status == '1'">
          <jw-button v-if="!nodeLoading && (data.node?.data.isType == 'current' || data.node?.data.status == '1')" @click="completeFlow" type="primary" size="small">完成节点</jw-button>
          <jw-button v-if="!nodeLoading && data.node?.data.status == '5'" @click="rollBackFlow" type="outline" size="small">回滚至当前节点</jw-button>
        </div>
      </div>
      <div class="node-owner pd-8" v-if="data.node">
        <div class="node-owner-person">节点负责人</div>
        <!-- assign:默认负责人，任何人不得更改负责人 -->
        <template v-if="data.nodeConfig?.ownerSettingType === 'assign'">
          <div :class="['owner-box', 'disable']">
            <template v-if="data.ownerList?.length">
              <div v-for="(item, index) of data.ownerList" :key="index">
                <xl-avatar :avatar="{ name: item?.userName || item?.name || '', url: item?.avatar || item?.avatarOrigin, id: item?.userId || item?.id }" :size="20" />
              </div>
            </template>
            <span v-else>暂无节点负责人</span>
          </div>
        </template>
        <template v-else-if="data.nodeConfig?.ownerSettingType === 'userField'">
          <div :class="['owner-box', 'disable']">
            <template v-if="data.ownerUserFieldsUserList?.length">
              <div v-for="(item, index) of data.ownerUserFieldsUserList" :key="index" class="owner-item">
                <xl-avatar :avatar="{ name: item?.userName || item?.name || '', url: item?.avatar || item?.avatarOrigin, id: item?.userId || item?.id }" :size="22" />
              </div>
            </template>
            <span v-else>暂无节点负责人</span>
            <user-field :detailData="dataInfo" :nodeConfig="data.nodeConfig" @cb="ownerUserFieldsUserRefresh"> </user-field>
          </div>
        </template>
        <template v-else>
          <div class="owner-box">
            <template v-if="data.ownerList?.length">
              <div v-for="(item, index) of data.ownerList" :key="index" class="owner-item">
                <xl-avatar :avatar="{ name: item?.userName || item?.name || '', url: item?.avatar || item?.avatarOrigin, id: item?.userId || item?.id }" :size="22" />
              </div>
            </template>
            <span v-else>暂无节点负责人</span>
            <xl-tree-member-modal :tree="userTree" @cb="getVal($event)" :user="recipientList" :memberNumber="5">
              <icon-edit />
            </xl-tree-member-modal>
          </div>
        </template>

        <template v-if="data.flowInfo?.status !== 5 && data.flowInfo?.status !== 2">
          <template v-if="data.nodeConfig?.status == 1 || data.nodeConfig?.status == 0">
            <jw-tooltip content="催一下" v-if="showDing && (data.ownerList?.length || data.ownerUserFieldsUserList?.length)">
              <qf-icon-ding class="icon-moon" @click="handleDing" />
            </jw-tooltip>
          </template>
        </template>
      </div>
      <!-- 任务列表 -->
      <task ref="taskRef" :key="data.taskKey" :node="data.node" :taskList="data.taskList" @cb="getNodeTableListByNodeId"></task>
      <jw-modal v-model:visible="modalState.visible" title-align="start" width="640px" :mask-closable="false" unmount-on-close :ok-loading="loading" ok-text="提交" :bodyStyle="{ padding: '12px 20px' }" :on-before-ok="handleOk" @cancel="handleCancel">
        <template #title> {{ modalState.type === 1 ? '终止流程' : '是否确认回滚节点？' }}</template>
        <jw-form :model="modalState.form" label-align="left" ref="modalFormRef" auto-label-width @submit="handleSubmit">
          <jw-form-item :label="modalState.type === 1 ? $t('请填写终止原因') : '请填写回滚原因'" field="reason" :rules="{ required: true, message: modalState.type === 1 ? $t('请填写终止原因') : '请填写回滚原因' }" :validate-trigger="['blur', 'change']" asterisk-position="end">
            <jw-textarea v-model="modalState.form.reason" :placeholder="modalState.type === 1 ? '请填写终止原因' : '请填写回滚原因'" :max-length="200" allow-clear show-word-limit :auto-size="{ minRows: 2, maxRows: 5 }" />
          </jw-form-item>
        </jw-form>
      </jw-modal>
    </jw-card>
    <operation-modal ref="operationRef" />
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref, nextTick, inject } from 'vue';
import drawFlow from './components/draw-flow/draw-flow.vue';
import task from './components/task/task.vue';
import operationModal from './components/operation-modal/operation.vue';
import userField from './components/user-field/user-field.vue';
import { Message, Modal } from '@arco-design/web-vue';
import { publicService } from '@/api/';
import { useGrayscaleStore } from '@/store';
import { tools } from '@/utils/tools';
import useEventListener from '@/hooks/event-listener';
const { eventListener } = useEventListener();
import { provide } from 'vue';
const props = defineProps({
  detailData: {
    type: [Object],
    default: () => {}
  }
});
const dataInfo = computed(() => props.detailData);
console.log('dataInfo', dataInfo);
const modalState = reactive({
  visible: false,
  type: 1,
  form: {
    reason: ''
  }
});

const operationRef = ref(null);
const taskRef = ref(null);

const modalFormRef = ref(null);
const nodeSubmitting = ref(false);
const grayscaleStore = useGrayscaleStore();
const grayList = computed(() => grayscaleStore.grayList);

const showDing = ref(true);
const detailRefresh = inject('detailParams')?.detailRefresh;

const data = reactive({
  // true 激活
  isStartFlow: true,
  popupVisible: false,
  node: null,
  flowInfo: null,
  scrollNum: 0,
  taskKey: 0,
  taskList: [], // 任务列表
  ownerList: [], // 负责人列表
  nodeConfig: {}, //节点配置信息
  ownerUserFieldsUserList: [],
  scrollableDivWidth: 0
});
const drawFlowRef = ref();

//查看操作记录
const checkOperation = () => {
  operationRef.value.openModal({
    instanceId: data.flowInfo?.instanceId
  });
};

//弹窗完成按钮
const handleOk = () => {
  modalFormRef.value.handleSubmit();
  return false;
};

// 关闭弹窗
const handleCancel = () => {
  modalState.visible = false;
};

// 原因表单提交
const handleSubmit = async ({ values, errors }) => {
  console.log('handleSubmit', errors, values);

  if (errors) {
    const errorArray = {};
    Object.values(errors).forEach((key, index) => {
      errorArray[key.field] = { status: 'error', message: '' };
      Object.values(errorArray).forEach((i, ind) => {
        if (index === ind) {
          i.message = key.message;
        }
      });
    });
    modalFormRef.value.setFields(errorArray);
    data.visible = true;
    return;
  }
  modalState.type === 1 ? terminate() : commitOrRollback();
};

const ownerUserFieldsUserRefresh = () => {
  detailRefresh();
  getNodeTableListByNodeId();
};

const nodeLoading = ref(false);
// 获取节点下的任务
const getNodeTableListByNodeId = async () => {
  try {
    const params = {
      nodeId: data.node?.adminId
    };
    nodeLoading.value = true;
    const json = await publicService.getNodeTableListByNodeId(params);
    if (!json.error) {
      console.log('getNodeTableListByNodeId', json);
      const { taskList, ownerList, nodeConfig } = json.result;
      data.taskList = taskList;
      data.ownerList = ownerList;
      data.nodeConfig = nodeConfig;
      data.taskKey += 1;
      showDing.value = true;

      // 联动人员字段 聚合
      data.ownerUserFieldsUserList = [];
      console.log('data.nodeConfig', data.nodeConfig);
      if (data.nodeConfig?.ownerUserFields && Array.isArray(data.nodeConfig?.ownerUserFields) && data.nodeConfig?.ownerUserFields?.length) {
        // 使用 flatMap 合并 values
        data.ownerUserFieldsUserList = data.nodeConfig?.ownerUserFields.flatMap((item) => item.values);
        const uniqueUsers = data.ownerUserFieldsUserList.reduce((acc, current) => {
          const existingUser = acc.find((user) => user.userId === current.userId);
          if (!existingUser) {
            acc.push(current);
          }
          return acc;
        }, []);
        data.ownerUserFieldsUserList = uniqueUsers;
      }
    }
    nodeLoading.value = false;
  } catch (e) {
    nodeLoading.value = false;
    // Message.error(e.message || e.statusText || '失败，请重试!');
  }
};

const recipientList = computed(() => {
  return data.ownerList.map((c) => c);
});

// 催一催
const handleDing = async () => {
  try {
    const json = await publicService.warnToNodeOwner({
      nodeId: data.node?.adminId
    });
    if (!json.error) {
      Message.success('已催促节点负责人尽快处理');
    }
  } catch (e) {
    Message.error(e.message || e.statusText || '失败，请重试!');
  }

  showDing.value = false;
};

// 修改节点负责人
const handleOwnerList = async (userList) => {
  const handlePersonList = userList.map((c) => c.id); // 选中的人的id集合

  /* 12345 --- 67890 --- 12345 */

  /* 12345 --- 1234 --- 5 */

  /* 123  --- 2345 --- 1*/

  try {
    const json = await publicService.updateNodeOwners({
      nodeId: data.node?.adminId,
      chargePersonList: handlePersonList, // 选中的人
      deleteChargePersonList: recipientList.value?.filter((rItem) => !handlePersonList.includes(rItem.id))?.map((hItem) => hItem.id) // 删除的人
    });
    if (json && !json.error) {
      Message.success('设置成功');
      getNodeTableListByNodeId();
    } else {
      Message.error(json.error?.msg || '失败，请重试!');
    }
  } catch (e) {
    Message.error(e.message || e.statusText || '失败，请重试!');
  }
};
console.log(handleOwnerList);

const getVal = (v) => {
  console.log(v, recipientList.value);
  const userList = v.userList; // 最终人员列表

  handleOwnerList(userList);
};

const getNode = (e) => {
  data.node = e;
  getNodeTableListByNodeId();
};
const isFinishedStatus = ref(false);
const isFinished = (e) => {
  isFinishedStatus.value = e;
};
const scrollableDiv = ref(null);

//终止接口
const terminate = async () => {
  try {
    const params = {
      entity: dataInfo.value.entity,
      businessId: dataInfo.value.id,
      propellerId: data.flowInfo.id,
      reason: modalState.form.reason
    };
    const json = await publicService.terminate(params);
    if (!json.error) {
      data.isStartFlow = false;
      await init();
      drawFlowRef.value.setflowKey();
      Message.success('终止成功');
      modalState.visible = false;
    } else {
      Message.error(json.error?.msg || '失败，请重试!');
    }
  } catch (e) {
    Message.error(e.message || e.statusText || '失败，请重试!');
  }
};

// 回滚至当前节点
const rollBackFlow = () => {
  modalState.visible = true;
  modalState.type = 2;
  modalState.form.reason = '';
};
const drawerRef = document.querySelector('.arco-drawer-body');
const scrollPosition = ref(0);
// 回滚至当前节点接口
const commitOrRollback = async () => {
  try {
    const params = {
      entity: dataInfo.value.entity,
      businessId: dataInfo.value.id,
      propellerId: data.flowInfo.id,
      id: data.node?.adminId || '',
      reason: modalState.form.reason
    };
    const json = await publicService.commitOrRollback(params);
    if (!json.error) {
      await init();
      drawFlowRef.value.setflowKey();
      Message.success('成功');
      modalState.visible = false;
      scrollPosition.value = drawerRef.scrollTop;
      detailRefresh?.(scrollPosition.value);
    } else {
      Message.error(json.error?.msg || '失败，请重试!');
    }
  } catch (e) {
    Message.error(e.message || e.statusText || '失败，请重试!');
  }
};

// 非灰度租户保持旧请求形态；只有灰度开启时才附带 nodeTaskIds 新参数。
const propeller = async ({ grayEnabled = false, nodeTaskIds = [] } = {}) => {
  if (nodeSubmitting.value) return;

  nodeSubmitting.value = true;
  try {
    const params = {
      entity: dataInfo.value.entity,
      businessId: dataInfo.value.id,
      propellerId: data.flowInfo.id,
      id: data.node.adminId || ''
    };

    if (grayEnabled) {
      params.nodeTaskIds = nodeTaskIds;
    }

    const json = await publicService.commitOrRollback(params);
    if (!json.error) {
      await init();
      drawFlowRef.value.setflowKey();
      Message.success('成功');
      scrollPosition.value = drawerRef.scrollTop;
      detailRefresh?.(scrollPosition.value);
    } else {
      Message.error(json.error?.msg || '失败，请重试!');
    }
  } catch (e) {
    Message.error(e.message || e.statusText || '失败，请重试!');
  } finally {
    nodeSubmitting.value = false;
  }
};

const checkNodesSuccess = async () => {
  const isFinished = data.flowInfo?.nodes.every((item) => item.status == 5);
  if (isFinished) isFinishedStatus.value = true;
};

const openCompleteFlowConfirm = ({ grayEnabled = false, nodeTaskIds = [] } = {}) => {
  Modal.confirm({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: '完成节点',
    content: '确认完成节点？',
    okText: '确定',
    cancelText: '取消',
    onOk: () => {
      return propeller({ grayEnabled, nodeTaskIds });
    }
  });
};

// 完成节点前，灰度内先走任务阻断与筛选逻辑；灰度外保持原有确认与提交链路。
const completeFlow = async () => {
  if (nodeSubmitting.value) return;

  const grayEnabled = Boolean(grayList.value?.['Process:commitNodeWithTasks']);

  if (!grayEnabled) {
    openCompleteFlowConfirm({ grayEnabled: false });
    return;
  }

  if (!taskRef.value?.getNodeCompleteTaskResult) {
    Message.error('任务区域未初始化，请稍后重试');
    return;
  }

  try {
    // 任务聚合层只返回稳定结构，主流程这里统一消费 pass/message，避免细节泄漏到界面层。
    const taskResult = await taskRef.value.getNodeCompleteTaskResult({ grayEnabled });

    if (!taskResult?.pass) {
      const failMessage = taskResult?.blockedTasks?.length ? '当前节点存在未完成的必做任务，无法完成该节点' : taskResult?.message || '任务区域未初始化，请稍后重试';
      Message.error(failMessage);
      return;
    }

    openCompleteFlowConfirm({
      grayEnabled: true,
      nodeTaskIds: taskResult?.nodeTaskIds || []
    });
  } catch (error) {
    Message.error(error?.message || '任务校验失败，请稍后重试');
  }
};

// 激活接口
const activate = async () => {
  try {
    const params = {
      entity: dataInfo.value.entity,
      businessId: dataInfo.value.id,
      propellerId: data.flowInfo.id,
      moduleId: ''
    };
    const json = await publicService.activate(params);
    if (!json.error) {
      data.isStartFlow = true;
      await init();
      Message.success('激活成功');
    } else {
      Message.error(json.error?.msg || '激活失败，请重试!');
    }
  } catch (e) {
    Message.error(e.message || e.statusText || '失败，请重试!');
  }
};
const debouncedRefreshKeyUpdate = tools.debounceFn(
  () => {
    data.scrollableDivWidth = scrollableDiv.value?.clientWidth || 0;
    if (drawFlowRef.value) {
      drawFlowRef.value.init();
    }
  },
  100,
  false
);

const refreshKeyUpdate = () => {
  debouncedRefreshKeyUpdate();
};
// 终止流程
const stopFlow = () => {
  modalState.visible = true;
  modalState.type = 1;
  modalState.form.reason = '';
};
const startFlow = () => {
  Modal.confirm({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: '激活流程',
    content: '确认激活流程？',
    okText: '确定',
    cancelText: '取消',
    onOk: () => {
      activate();
    }
  });
};

const init = async () => {
  try {
    const params = {
      entity: dataInfo.value.entity,
      businessId: dataInfo.value.id
    };
    const json = await publicService.flowDetail(params);
    if (!json.error) {
      data.flowInfo = json.result;
      await checkNodesSuccess();
    } else {
      Message.error(json.error?.msg || '获取详情失败，请重试!');
    }
  } catch (e) {
    console.log(e);
  }
};

onMounted(async () => {
  await init();
});

provide('taskParams', {
  entity: computed(() => dataInfo.value.entity),
  businessId: computed(() => dataInfo.value.id)
});

const scrollInit = (e) => {
  console.log('scrollInit', e);
  if (scrollableDiv.value) {
    nextTick(() => {
      if (e?.level > 2) {
        data.scrollNum = data.scrollNum + 1;
        // scrollableDiv.value.scrollLeft = e.level * 1 * 60;
        scrollableDiv.value.scrollLeft = e.sumNodeWidth;
      }
      if (e?.position.y > 250) {
        data.scrollNum = data.scrollNum + 1;
        scrollableDiv.value.scrollTop = 200;
      }
    });
  }
};
eventListener('resize', debouncedRefreshKeyUpdate);
const userTree = ref({
  checkDepartment: false,
  isAll: false
});

defineExpose({ init, getNodeTableListByNodeId, refreshKeyUpdate });
</script>
<style scoped lang="less">
@import './xl-flow-stage.less';
</style>
